module.exports = __webpack_public_path__ + "img/shopGuide2-b.ae442356.jpg";